import React from 'react';

import { MobileNav } from '.';
import { removeMobileNavClasses } from '../../modules/removeMobileNavClasses';

type MobileNavLinkProps = {
  label: string;
  key: string;
  to: string;
  isShowingNotificationBadge: boolean;
  notificationBadge: string;
  href: string;
  openInNewTab: boolean;
};

type MobileNavProps = {
  links: MobileNavLinkProps[];
  isSignedIn: boolean;
  onLogOut: () => void;
  onClickClose: () => void;
  pathname: string;
  isScalableAnalyticsEnabled: boolean;
};

class MobileNavContainer extends React.Component<MobileNavProps> {
  componentWillUnmount() {
    removeMobileNavClasses();
  }

  render() {
    const {
      links,
      isSignedIn,
      onLogOut,
      pathname,
      onClickClose,
      isScalableAnalyticsEnabled,
    } = this.props;
    return (
      <MobileNav
        pathname={pathname}
        links={links}
        isSignedIn={isSignedIn}
        onClickClose={onClickClose}
        onLogOut={onLogOut}
        isScalableAnalyticsEnabled={isScalableAnalyticsEnabled}
      />
    );
  }
}

export { MobileNavContainer };
